(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athlete-grid"] && !Shopify.designMode) return;
  try {
    
  
  
  document.getElementById('showAllButton').addEventListener('click', function() {
    var additionalItems = document.getElementById('additionalItems');
    
    if (additionalItems.classList.contains('show')) {
      // Start der Animation zum Verstecken
      additionalItems.classList.remove('show');
      // Warten auf das Ende der Animation, bevor display:none gesetzt wird
      setTimeout(() => {
        additionalItems.style.display = 'none';
      }, 500); // Warten auf das Ende der CSS-Transition
      this.textContent = 'Alle Athleten anzeigen';
    } else {
      // display:block setzen, bevor die Animation beginnt
      additionalItems.style.display = 'block';
      // Ein kleiner Timeout, um der 'display'-Eigenschaft Zeit zu geben, angewendet zu werden
      setTimeout(() => {
        additionalItems.classList.add('show');
      }, 10);
      this.textContent = 'Weniger anzeigen';
    }
  });
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlete"]) return;
  try {
    


document.getElementById('showAllButton').addEventListener('click', function() {
  var additionalItems = document.getElementById('additionalItems');
  
  if (additionalItems.classList.contains('show')) {
    // Start der Animation zum Verstecken
    additionalItems.classList.remove('show');
    // Warten auf das Ende der Animation, bevor display:none gesetzt wird
    setTimeout(() => {
      additionalItems.style.display = 'none';
    }, 500); // Warten auf das Ende der CSS-Transition
    this.textContent = 'Alle Athleten anzeigen';
  } else {
    // display:block setzen, bevor die Animation beginnt
    additionalItems.style.display = 'block';
    // Ein kleiner Timeout, um der 'display'-Eigenschaft Zeit zu geben, angewendet zu werden
    setTimeout(() => {
      additionalItems.classList.add('show');
    }, 10);
    this.textContent = 'Weniger anzeigen';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-json-faq"] && !Shopify.designMode) return;
  try {
    
(function initFAQ() {
    const toggleQuestion = (event) => {
        var x = event.target.parentElement.parentElement.getAttribute("aria-expanded"); 
        if (x == "true") {
            x = "false";
        } else {
            x = "true";
        }
        event.target.parentElement.parentElement.setAttribute("aria-expanded", x);
        event.target.parentElement.parentElement.nextElementSibling.classList.toggle("close");
    }
    const faqNodes = document.querySelectorAll('.faq-section h3');
    for (let i = 0; i < faqNodes.length; i++) {
        faqNodes[i].addEventListener("click", toggleQuestion);
    }   
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-usps"]) return;
  try {
    
    (function initUSPs() {
        const uspElement =  document.querySelector('#funkyUsps');
        if(uspElement != null) {
            let currentActiveElement = 1;

            const imageNodes =  document.querySelectorAll('#funkyUsps .imageCarousel div');
            const textNodes =  document.querySelectorAll('#funkyUsps .textCarousel div');
            const headlineNodes = document.querySelectorAll('#funkyUsps .headlineCarousel div');

            const rotateContent = () => {
                for (let i = 0; i < headlineNodes.length; i++) {
                    if(headlineNodes[i].classList.contains('active')) {
                        headlineNodes[i].classList.remove("active")
                    }
                }            
                headlineNodes[currentActiveElement].classList.add("active");

                for (let i = 0; i < imageNodes.length; i++) {
                    if(imageNodes[i].classList.contains('active')) {
                        imageNodes[i].classList.remove("active")
                    }
                }             
                imageNodes[currentActiveElement].classList.add("active");


                for (let i = 0; i < textNodes.length; i++) {
                    if(textNodes[i].classList.contains('active')) {
                        textNodes[i].classList.remove("active")
                    }
                }             
                textNodes[currentActiveElement].classList.add("active");            
            }

            const backButton = document.querySelector('#funkyUsps .imageCarousel .back');
            const forwardButton = document.querySelector('#funkyUsps .imageCarousel .forward');

            const buttonClick = (event) => {
                let element = event.currentTarget;

                if (element.classList.contains('back')) {
                    currentActiveElement = (currentActiveElement + 2) % 3;
                }

                if (element.classList.contains('forward')) {
                    currentActiveElement = (currentActiveElement + 1) % 3;
                }
                                    
                rotateContent();
            }

            const toggleHeadline = (event) => {
                currentActiveElement = event.currentTarget.dataset.count;  
                rotateContent();
            }        

            for (let i = 0; i < headlineNodes.length; i++) {
                headlineNodes[i].addEventListener("click", toggleHeadline);
            }        

            backButton.addEventListener("click", buttonClick);
            forwardButton.addEventListener("click", buttonClick);
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-metaobject-picker"] && !Shopify.designMode) return;
  try {
    
(function initFAQ() {
  const toggleQuestion = (event) => {
    const button = event.target.closest('button.faq-question');
    if (!button) return;
    const expanded = button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
    button.setAttribute('aria-expanded', expanded);
    button.nextElementSibling.classList.toggle('close');
  };
  document.querySelectorAll('.faq-section button.faq-question').forEach((btn) => {
    btn.addEventListener('click', toggleQuestion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mighty-performance-stage"]) return;
  try {
    
  (function initMightyStage() {
      const volumeButton = document.querySelector('#videoSound');
      const videoContainer = document.querySelector('#performant-video');
      const toggleAudio = (event) => {
          videoContainer.muted ? videoContainer.muted = false : videoContainer.muted = true;
          volumeButton.classList.toggle("volumenOn");
      }
      volumeButton.addEventListener("click", toggleAudio);
  
      videoContainer.addEventListener('loadeddata', function() {
          volumeButton.classList.toggle("hidden");
      });
  
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-product-badges"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const badgeContainer = document.querySelector(".badgeContainer");
  const productGallery = document.querySelector(".product-gallery");

  if (!badgeContainer || !productGallery) return;

  const firstImage = badgeContainer.querySelector("img");
  if (!firstImage) return;

  const badgeClone = document.createElement("div");
  badgeClone.classList.add("badgeContainer--gallery");

  // Wrapper für Tooltip
  const wrapper = document.createElement("div");
  wrapper.classList.add("badge-tooltip");

  const imgClone = firstImage.cloneNode(true);
  imgClone.loading = "eager";

  if (imgClone.alt) {
    wrapper.setAttribute("data-tooltip", imgClone.alt);
  }

  wrapper.appendChild(imgClone);
  badgeClone.appendChild(wrapper);

  if (getComputedStyle(productGallery).position === "static") {
    productGallery.style.position = "relative";
  }

  productGallery.appendChild(badgeClone);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-article-air-calc"]) return;
  try {
    
  (function initTOC() {
      var headers = document.querySelectorAll(".article--content h2");
      var tocContainer = document.getElementById("toc");
      headers.forEach(function(header) {
          var headerId = header.textContent.replace(/\s/g, "-").toLowerCase();
          header.id = headerId;
          var anker = document.createElement('a');
          anker.setAttribute('href', '#' + headerId);
          anker.innerText = header.textContent;
          tocContainer.appendChild(anker);
      });
      if (tocContainer.hasChildNodes()) {
        tocContainer.classList.add("styled");
      }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-article-pct"]) return;
  try {
    
  (function initTOC() {
      var headers = document.querySelectorAll(".article--content h2");
      var tocContainer = document.getElementById("toc");
      headers.forEach(function(header) {
          var headerId = header.textContent.replace(/\s/g, "-").toLowerCase();
          header.id = headerId;
          var anker = document.createElement('a');
          anker.setAttribute('href', '#' + headerId);
          anker.innerText = header.textContent;
          tocContainer.appendChild(anker);
      });
      if (tocContainer.hasChildNodes()) {
        tocContainer.classList.add("styled");
      }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-article"]) return;
  try {
    
(function initMagazineLayout() {
  const tocContainer = document.getElementById("toc");
  const article = document.querySelector(".article--content");

  if (!tocContainer || !article) return;

  // Initialisierung des TOC-Styles
  if (tocContainer.getElementsByTagName('a').length > 0) {
    tocContainer.classList.add("styled");
  }

  /**
   * Intersection Observer für den Active State (Underline-Effekt)
   * Markiert Links im Inhaltsverzeichnis, wenn die Überschrift gescrollt wird.
   */
  const handleActiveState = () => {
    const tocLinks = tocContainer.querySelectorAll('a');
    const headings = article.querySelectorAll('h2');

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -80% 0px', // Triggert im oberen Bereich des Viewports
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          tocLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === '#' + id) {
              link.classList.add('active');
            }
          });
        }
      });
    }, observerOptions);

    headings.forEach(h2 => observer.observe(h2));
  };

  // Starte Observer, wenn das DOM bereit ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleActiveState);
  } else {
    handleActiveState();
  }
})();

(function wrapArticleTables() {
  var article = document.querySelector('.article--content.rte');
  if (!article) return;
  article.querySelectorAll('table').forEach(function (table) {
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'overflow-x:auto;-webkit-overflow-scrolling:touch;width:100%;max-width:100%;';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();

(function initArticleProgressBar() {
  const progressBar = document.createElement('div');
  progressBar.id = 'article-progress-bar';
  
  Object.assign(progressBar.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '0%',
    height: '7px',
    backgroundColor: '#93caff',
    zIndex: '9999',
    transition: 'width 0.1s ease-out'
  });
  
  document.body.appendChild(progressBar);

  const article = document.querySelector('.article--content.rte');
  if (!article) return;

  window.addEventListener('scroll', () => {
    const viewportHeight = window.innerHeight;
    const articleHeight = article.offsetHeight;
    const startOffset = article.offsetTop;
    
    const scrolled = window.pageYOffset - startOffset;
    const scrollLimit = articleHeight - viewportHeight;

    if (scrolled <= 0) {
      progressBar.style.width = '0%';
    } else if (scrolled >= scrollLimit) {
      progressBar.style.width = '100%';
    } else {
      const scrollPercent = (scrolled / scrollLimit) * 100;
      progressBar.style.width = scrollPercent + '%';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-dictionary-article"]) return;
  try {
    
(function initMagazineLayout() {
  const tocContainer = document.getElementById("toc");
  const article = document.querySelector(".article--content");

  if (!tocContainer || !article) return;

  if (tocContainer.getElementsByTagName('a').length > 0) {
    tocContainer.classList.add("styled");
  }

  const handleActiveState = () => {
    const tocLinks = tocContainer.querySelectorAll('a');
    const headings = article.querySelectorAll('h2');

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -80% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          tocLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === '#' + id) {
              link.classList.add('active');
            }
          });
        }
      });
    }, observerOptions);

    headings.forEach(h2 => observer.observe(h2));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleActiveState);
  } else {
    handleActiveState();
  }
})();

(function initArticleProgressBar() {
  const progressBar = document.createElement('div');
  progressBar.id = 'article-progress-bar';

  Object.assign(progressBar.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '0%',
    height: '7px',
    backgroundColor: '#93caff',
    zIndex: '9999',
    transition: 'width 0.1s ease-out'
  });

  document.body.appendChild(progressBar);

  const article = document.querySelector('.article--content.rte');
  if (!article) return;

  window.addEventListener('scroll', () => {
    const viewportHeight = window.innerHeight;
    const articleHeight = article.offsetHeight;
    const startOffset = article.offsetTop;

    const scrolled = window.pageYOffset - startOffset;
    const scrollLimit = articleHeight - viewportHeight;

    if (scrolled <= 0) {
      progressBar.style.width = '0%';
    } else if (scrolled >= scrollLimit) {
      progressBar.style.width = '100%';
    } else {
      const scrollPercent = (scrolled / scrollLimit) * 100;
      progressBar.style.width = scrollPercent + '%';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
